@if (graphComponent && linqset) {
    <mat-tab-group style="padding:10px;">
        <mat-tab>
            <ng-template mat-tab-label>
                <span class="material-symbols-outlined tab-icon" aria-hidden="true" title="Overview">overview</span>
                <span class="tab-text">Overview</span>
            </ng-template>

            <app-insights-overview [linqset]="linqset" [graph]="graphComponent.graph" [comparison]="comparison" [trigger]="refreshTrigger" (selectNodeEvent)="selectNodes([$event])"></app-insights-overview>
        </mat-tab>
        <mat-tab>
            <ng-template mat-tab-label>
                <span class="material-symbols-outlined tab-icon" aria-hidden="true" title="Nodes">graph_3</span>
                <span class="tab-text">Nodes</span>
            </ng-template>

            @defer {
                <app-node-table [linqset]="linqset" [comparison]="comparison" [trigger]="refreshTrigger" [organisationLinqset]="repoService.organisationLinqset" [graphComponent]="graphComponent" [selectedTagGroup]="selectedTagGroup" [isGrouped]="isGrouped" [multiSelect]="true" (selectNodeEvent)="selectNodes($event)" (selectEdgeEvent)="selectEdges([$event])"></app-node-table>
            }
        </mat-tab>
        @if (!linqset.isTutorial()) {
            @if (linqset.insights.informationAssets && linqset.insights.informationAssets.length > 0) {
                <mat-tab label="Assets">
                    <ng-template mat-tab-label>
                        <span class="material-symbols-outlined tab-icon" aria-hidden="true" title="Assets">web_asset</span>
                        <span class="tab-text">Assets</span>
                    </ng-template>

                    @defer {
                        <app-information-asset-table [linqset]="linqset" (selectNodeEvent)="selectNodes([$event])"></app-information-asset-table>
                    }
                </mat-tab>
            }
            <!-- the EPM scorecard, workforce and systems reports are of the organisation's analysis, so are on the analysis
                 pages rather than beside a model being edited -->
            <mat-tab>
                <ng-template mat-tab-label>
                    <span class="material-symbols-outlined tab-icon" aria-hidden="true" title="AI Summary (Beta)">wand_stars</span>
                    <span class="tab-text">AI Summary (Beta)</span>
                </ng-template>
                
                @defer {
                    <div class="card-container">
                        <app-query-ai [linqset]="linqset"></app-query-ai>
                    </div>
                }
            </mat-tab>
            <mat-tab>
                <ng-template mat-tab-label>
                    <span class="material-symbols-outlined tab-icon" aria-hidden="true" title="Warnings">warning</span>
                    <span class="tab-text">Warnings</span>
                </ng-template>

                @defer {
                    <app-warnings [linqset]="linqset" (selectNodeEvent)="selectNodes([$event])" [graphComponent]="graphComponent"></app-warnings>
                }
            </mat-tab>
            <mat-tab>
                <ng-template mat-tab-label>
                    <span class="material-symbols-outlined tab-icon" aria-hidden="true" title="Statistics">monitoring</span>
                    <span class="tab-text">Statistics</span>
                </ng-template>

                @defer {
                    @if (lineData && analyticsData) {
                        @if (isHelpOn()) {
                            <div class="hint">Shows changes made to this model or organisation. You can turn on/off data sets by clicking on the legend.</div>
                        }
                        <app-line-chart [data]="lineData" [width]="800" [height]="400"></app-line-chart>
                        <app-analytics-table [data]="analyticsData.analytics"></app-analytics-table>
                    }
                }
            </mat-tab>
            @if (isProject()) {
                <mat-tab>
                    <ng-template mat-tab-label>
                        <span class="material-symbols-outlined tab-icon" aria-hidden="true" title="Projects">work</span>
                        <span class="tab-text">Projects</span>
                    </ng-template>

                    @defer {
                        <app-project-details [refreshTrigger]="refreshTrigger" [linqset]="linqset" [comparison]="comparison"></app-project-details>
                    }
                </mat-tab>
            }
        }
    </mat-tab-group>
}
